var i = /* @__PURE__ */ ((o) => (o.HUMAN = "human", o.MANMADE = "manmade", o))(i || {});
const r = 4, d = [
  {
    value: "",
    label: "not use"
  }
];
var n = /* @__PURE__ */ ((o) => (o.Placement = "Placement", o.Background = "Background", o.Detail = "Detail", o))(n || {}), t = /* @__PURE__ */ ((o) => (o.toBeConfirmed = "toBeConfirmed", o.auditing = "auditing", o.approved = "approved", o.Ongoing = "Ongoing", o.finished = "finished", o))(t || {}), a = /* @__PURE__ */ ((o) => (o.kol = "kol", o.brand = "brand", o))(a || {}), u = /* @__PURE__ */ ((o) => (o.ad = "ad", o.kol = "kol", o.verified = "verified", o))(u || {}), c = /* @__PURE__ */ ((o) => (o.CE = "ce", o.AA = "aa", o.IT = "it", o.PD = "pd", o))(c || {});
const m = {
  ce: "crystal-ball",
  aa: "bubbles",
  it: "smiling-face-with-sunglasses",
  pd: "writing-hand-medium-light-skin-tone"
}, h = 20 * 1024 * 1024, l = ["image/png", "image/jpg", "image/jpeg"];
var s = /* @__PURE__ */ ((o) => (o.NORMAL = "normal", o.BUTTON = "button", o))(s || {}), g = /* @__PURE__ */ ((o) => (o.xiaohongshu = "xiaohongshu", o.douyin = "douyin", o.tiktok = "tiktok", o.youtube = "youtube", o))(g || {});
const v = {
  xiaohongshu: "icon-xiaohongshu",
  douyin: "mogic-douyin",
  tiktok: "mogic-douyin",
  youtube: "mogic-youtube-c",
  upload: "mogic-upload-info",
  you_cloud: "mogic-youmi",
  juliang_yuntu: "mogic-yuntu",
  juliang_creative: "mogic-chuangyi",
  tiktok_creative: "mogic-douyin"
}, k = {
  xiaohongshu: "https://mogic-static.oss-cn-hangzhou.aliyuncs.com/vida/Group%202330.svg",
  douyin: "https://mogic-static.oss-cn-hangzhou.aliyuncs.com/vida/Group%202331.svg",
  tiktok: "https://mogic-static.oss-cn-hangzhou.aliyuncs.com/vida/Group%202331.svg",
  youtube: "https://mogic-static.oss-cn-hangzhou.aliyuncs.com/vida/mogic-youtube-c.svg"
}, y = {
  xiaohongshu: ["www.xiaohongshu.com", "xhslink.com"],
  douyin: ["www.douyin.com", "v.douyin.com"],
  tiktok: ["www.tiktok.com"],
  youtube: []
};
var e = /* @__PURE__ */ ((o) => (o.DESC = "desc", o.ASC = "asc", o))(e || {});
export {
  g as Channel,
  y as ChannelDetailHost,
  v as ChannelMapIcon,
  k as ChannelMapImg,
  r as DEFAULT_RESULT_IMG_NUM,
  t as DEMAND_STATUS,
  a as FollowType,
  h as MAX_IMG_SIZE_BYTE,
  d as NOT_USE_OPTION,
  n as PromptEnum,
  m as RoleEmojiMap,
  c as RoleType,
  e as SORT_TYPE,
  i as TEMPLATE_TYPE,
  l as UPLOAD_ACCEPT_TYPE,
  s as UPLOAD_CLICK_FROM,
  u as VideoType
};
